const businessLandingEN = {
	hero: {
		title: "Your business, growing and stress-free",
		subtitle:
			"Whether you have a business or want to start one, Sin Fila automates bookings, reminders, and team management, while helping you attract more clients.",
		primaryCta: "Register now for free",
		storeText: "Available on iOS . Android",
		noteStrong: "Set up your business in just 15 min",
		noteRest: " • Hassle-free, no contracts • Cancel anytime",
	},

	problem: {
		title: "The real problem",
		subtitle: "Does this sound familiar?",
		items: [
			"📱 Responding to WhatsApp all day (and night)",
			"📆 Overlapping schedules or empty slots",
			"🚶 Clients arrive, see a long line… and leave",
			"😤 All clients arrive at the same time",
			"📊 Not knowing how many clients you served this month",
		],
		itemspart2: [
			"If there’s no customers → you lose time",
			"If there’s too much line → you lose clients."
		],
		description:
			"💸 Every client who leaves because of the line is lost revenue.",
		highlight:
			"👉 Many businesses lose up to 20% of their income due to poor scheduling, empty time slots, and clients leaving when they see a line.",
	},

	didYouKnow: {
		title: "Did you know...",
		items: [
			"More than 70% of clients prefer booking online if possible",
			"Automating bookings removes WhatsApp messages all day",
			"Automatic reminders reduce no-shows",
			"Online visibility brings new clients without paying for ads",
		],
		highlight:
			"✅ Sin Fila organizes your schedule so you don’t lose clients — and gives your business online visibility to grow.",
	},

	solution: {
		title: "Sin Fila solves it",
		points: [
			{
				title: "Never miss a booking",
				desc: "All appointments, confirmations, and reminders in one place.",
			},
			{
				title: "Attract new clients and fill your schedule",
				desc: "Show your business to more clients in our marketplace.",
			},
			{
				title: "Save time managing your shop and staff",
				desc: "Manage your services and staff calendars effortlessly.",
			},
			{
				title: "Effortless bookings for your clients",
				desc: "Clients book, modify, and get reminders automatically.",
			},
		],
		screens: {
			title: "Flip through 4 screenshots",
			items: [
				"Calendar (multi)",
				"Explore (see 2–3 shops)",
				"Manage shop page",
				"Customer booking page",
			],
		},
	},

	pricing: {
		title: "A simple plan, everything included",
		planTitle: "A simple plan — pay only for what you use:",
		planItems: [
			"💳 $15 USD / month — first user",
			"👥 $12 USD / month — per additional user",
		],
		note:
			"No contracts. No hidden charges. Cancel anytime.",
		autoTitle: "Paying for Sin Fila is simple and automatic:",
		autoItems: [
			"We accept credit and debit cards directly on the platform",
			"Billing happens automatically every month",
			"You can cancel anytime, no contracts or commitments",
		],
	},

	referral: {
		banner:
			"Referral program to give you free months!! One referral, one free user per month!!",
		steps: [
			"Step 1: send your referral code",
			"Step 2: invitee completes their registration",
			"Step 3: both get a free month for a user",
			"* Details available in the app",
		],
	},

	final: {
		text:
			"Register now for free, and take advantage of our attractive referral program",
		button: "Register Now for free",
	},
};

export default businessLandingEN;